import { render, staticRenderFns } from "./profile-authorizations.vue?vue&type=template&id=a20751d4&scoped=true"
import script from "./profile-authorizations.vue?vue&type=script&lang=js"
export * from "./profile-authorizations.vue?vue&type=script&lang=js"
import style0 from "./profile-authorizations.vue?vue&type=style&index=0&id=a20751d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20751d4",
  null
  
)

export default component.exports